export default __webpack_public_path__ + "static/media/CamerasEverywhere.48dea9eb.pdf";